import { useLanguage } from '@/lib/i18n';
import { motion } from 'framer-motion';
import { Shield, Star, Handshake } from 'lucide-react';

const features = [
  { icon: Shield, titleKey: 'feat.legal.title', descKey: 'feat.legal.desc' },
  { icon: Star, titleKey: 'feat.quality.title', descKey: 'feat.quality.desc' },
  { icon: Handshake, titleKey: 'feat.fair.title', descKey: 'feat.fair.desc' },
];

const FeaturesSection = () => {
  const { tr } = useLanguage();

  return (
    <section className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feat, i) => (
            <motion.div
              key={feat.titleKey}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.15 }}
              className="bg-card rounded-xl p-8 card-shadow hover:card-shadow-hover transition-shadow text-center"
            >
              <div className="w-14 h-14 mx-auto rounded-full bg-primary/10 flex items-center justify-center mb-5">
                <feat.icon className="w-7 h-7 text-primary" />
              </div>
              <h3 className="font-heading text-xl font-semibold text-foreground mb-3">{tr(feat.titleKey)}</h3>
              <p className="text-muted-foreground text-sm leading-relaxed">{tr(feat.descKey)}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
